const { packages, globalPackages } = require('./hatch.packages');
const hatchStore = {
  intervalIds: [],
  timeoutIds: [],
  windowEventListeners: [],
  documentEventListeners: []
};

// window.setInterval = new Proxy(setInterval, {
//   apply: function(target, thisArg, argumentsList) {
//     const intervalId = target(...argumentsList);
//     //  Todo: make this operation atomic
//     hatchStore.intervalIds.push(intervalId);
//     return intervalId;
//   }
// });

// window.setTimeout = new Proxy(setTimeout, {
//   apply: function(target, thisArg, argumentsList) {
//     const timeoutId = target(...argumentsList);
//     //  Todo: make this operation atomic
//     hatchStore.timeoutIds.push(timeoutId);
//     return timeoutId;
//   }
// });

// window.addEventListener = new Proxy(window.addEventListener, {
//   apply: function(...args) {
//     const [target, thisArg, argumentsList] = args;
//     const [event, funRef, useCapture] = argumentsList;
//     hatchStore.windowEventListeners.push({
//       target,
//       thisArg,
//       argumentsList
//     });
//     target.apply(thisArg, argumentsList);
//   }
// });

// document.addEventListener = new Proxy(document.addEventListener, {
//   apply: function(...args) {
//     const [target, thisArg, argumentsList] = args;
//     const [event, funRef, useCapture] = argumentsList;
//     hatchStore.documentEventListeners.push({
//       target,
//       thisArg,
//       argumentsList
//     });
//     target.apply(thisArg, argumentsList);
//   }
// });

// document.removeEventListener = new Proxy(document.removeEventListener, {
//   apply: function(...args) {
//     const [target, thisArg, argumentsList] = args;
//     const [event, funRef, useCapture] = argumentsList;
//     //  find the matching event and funRef in the store
//     const eventFound = hatchStore.documentEventListeners.find(evt => {
//       const [insideEvent, insideFunRef, insideUseCapture] = evt.argumentsList;
//       if (
//         insideEvent === event &&
//         funRef === insideFunRef &&
//         useCapture === insideUseCapture
//       ) {
//         return true;
//       }
//       return false;
//     });
//     if (eventFound) {
//       console.log('eventFound: ', eventFound);
//       target.apply(thisArg, eventFound.argumentsList);
//     }
//   }
// });

// const removeEventListeners = elm => {
//   const eventsMap = getEventListeners(elm);
//   const eventNames = Object.keys(eventsMap);
//   for (let i = 0; i < eventNames.length; i++) {
//     const eventName = eventNames[i];
//     const events = eventsMap[eventName];
//     for (let j = 0; j < events.length; j++) {
//       const eventPayload = events[j];
//       elm.removeEventListener(
//         eventPayload.type,
//         eventPayload.listener,
//         eventPayload.useCapture
//       );
//     }
//   }
// };

// const removeAllDocumentEventListeners = () => {
//   for (let i = 0; i < hatchStore.documentEventListeners.length; i++) {
//     const eventListenersPayload = hatchStore.documentEventListeners[i];
//     document.removeEventListener(...eventListenersPayload.argumentsList);
//   }
//   hatchStore.documentEventListeners = [];
// };

// const removeAllWindowEventListeners = () => {
//   for (let i = 0; i < hatchStore.documentEventListeners.length; i++) {
//     const eventListenersPayload = hatchStore.windowEventListeners[i];
//     window.removeEventListener(...eventListenersPayload.argumentsList);
//   }
//   hatchStore.windowEventListeners = [];
// };

// const stopIntervals = () => {
//   for (let i = 0; i < hatchStore.intervalIds.length; i++) {
//     clearInterval(hatchStore.intervalIds[i]);
//   }
//   hatchStore.intervalIds = [];
// };

// const stopTimeouts = () => {
//   for (let i = 0; i < hatchStore.timeoutIds.length; i++) {
//     clearTimeout(hatchStore.timeoutIds[i]);
//   }
//   hatchStore.timeoutIds = [];
// };

// const stopScripts = () => {
//   //  remove the scripts from the head
//   stopIntervals();
//   stopTimeouts();
//   // removeEventListeners(document);
//   // removeEventListeners(window);
//   removeAllDocumentEventListeners();
// };

// const resetScene = ({ index = 0, template }) => {
//   //  stop scripts
//   stopScripts();
//   if (!template) {
//     template = AFRAME.scenes[index].outerHTML;
//   }
//   AFRAME.scenes[index].outerHTML = template;
// };

const appendScript = async (src, doc) =>
  new Promise(resolve => {
    const startDate = new Date();
    const script = doc.createElement('script');
    script.src = src;
    doc.head.appendChild(script);
    script.addEventListener('load', () => {
      const endDate = new Date();
      const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      console.log('script loaded: ', src, `took ${seconds} to load`);
      resolve();
    });
  });

const createEntityFromString = template => {
  var wrapper = document.createElement('div');
  wrapper.innerHTML = template;
  return wrapper.firstChild;
};

const isAnyIntersectionArr = (first, second) => {
  for (let i = 0; i < second.length; i++) {
    if (first.includes(second[i])) {
      return true;
    }
  }
  return false;
};

const checkComponent = async component => {
  const isComponentPresent = Object.keys(AFRAME.components).includes(component);
  //  if the component is not present find the component in the packages and load the script
  if (!isComponentPresent) {
    const packagesKeys = Object.keys(packages);
    for (let i = 0; i < packagesKeys.length; i++) {
      const packageKey = packagesKeys[i];
      const packageObj = packages[packageKey];
      const { components, script } = packageObj;
      if (components.includes(component)) {
        await appendScript(script, document);
      }
    }
  }
  return isComponentPresent;
};

const checkEntity = async entity => {
  const components = [...entity.attributes];
  for (let i = 0; i < components.length; i++) {
    const component = components[i].localName;
    const packagesKeys = Object.keys(packages);
    if (!AFRAME.components[component]) {
      //  if the component is found in the local packages load the script of the package
      for (let j = 0; j < packagesKeys.length; j++) {
        const packageKey = packagesKeys[j];
        const packageObj = packages[packageKey];
        //  if the component is present load the component
        const { components: packageComponents, script } = packageObj;
        console.log('packageComponents: ', packageComponents, component);
        if (packageComponents.includes(component)) {
          //  component is found load the script
          console.log('loading the script', script);
          await appendScript(script, document);
        }
      }
    }
  }
};

const loadScene = async (
  template,
  { isJson = false, parentEl, scenePaused = false }
) => {
  //  load the global packages
  const globalPackagesKeys = Object.keys(globalPackages);
  for (let i = 0; i < globalPackagesKeys.length; i++) {
    const packageKey = globalPackagesKeys[i];
    const packageObj = globalPackages[packageKey];
    const { script, components } = packageObj;
    console.log('load the script: ', script);
    await appendScript(script, document);
  }
  //  we don't support json for now
  const scene = createEntityFromString(template);
  const packagesKeys = Object.keys(packages);
  for (let i = 0; i < packagesKeys.length; i++) {
    const packageKey = packagesKeys[i];
    const packageObj = packages[packageKey];
    const { components, script } = packageObj;
    //   check if the components is present in the scene
    for (let j = 0; j < components.length; j++) {
      const component = components[j];
      if (scene.querySelector(`[${component}]`)) {
        //  if the component is present load the component
        console.log('load the script: ', script);
        await appendScript(script, document);
        continue;
      }
    }
  }

  if (scenePaused) {
    scene.setAttribute('scenePaused', scenePaused);
  }
  parentEl.appendChild(scene);
};

// module.exports.resetScene = resetScene;
// module.exports.stopScripts = stopScripts;
// module.exports.stopIntervals = stopScripts;
// module.exports.stopTimeouts = stopTimeouts;
module.exports.loadScene = loadScene;
module.exports.hatchStore = hatchStore;
module.exports.checkEntity = checkEntity;
module.exports.checkComponent = checkComponent;
